export const diaSemana = (fechaString) => {
    const diasSemana = ['DOM', 'LUN', 'MAR', 'MIE', 'JUE', 'VIE', 'SAB']
    const fecha = new Date(fechaString)
    return diasSemana[fecha.getUTCDay()]
}

export const mes = (fechaString) => {
    const mesesAbreviados = ['ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC']
    const fecha = new Date(fechaString)
    return mesesAbreviados[fecha.getUTCMonth()]
}

export const shortDateFormat = (stringDate) => {
    const date = new Date(stringDate)

    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear().toString().slice(-2)
    const time = date.toTimeString().slice(0, 8)

    return `${day}/${month}/${year} ${time}`
}
